/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    REQUEST_USERS,
    RECEIVE_USERS
} from "./UsersActions";


const initialState = {
    users: [],
    loading: false,
}

export const users = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_USERS:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_USERS:
            return {
                ...state,
                loading: false,
                users: action.users,
            }
        default:
            return state
    }
}